/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AnnouncementFromJSON, AnnouncementToJSON } from './Announcement';
export function GetAnnouncementResponseDataFromJSON(json) {
    return GetAnnouncementResponseDataFromJSONTyped(json, false);
}
export function GetAnnouncementResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        announcement: !exists(json, 'announcement') ? undefined : AnnouncementFromJSON(json['announcement'])
    };
}
export function GetAnnouncementResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        announcement: AnnouncementToJSON(value.announcement)
    };
}
